import { useI18n } from '../../hooks/useI18nFormatters';
import { useCapabilityValue } from '../../store/devices/useCapabilityValue';

import styles from './IndicatorSpeaker.module.css';

import { DeviceTile } from './DeviceTile';
import { SpeakerEqualizer } from './SpeakerEqualizer';

const pausedFallbackLabel = 'Paused';
const playingFallbackLabel = 'Playing';

export function IndicatorSpeaker(props) {
  const { i18n } = useI18n();
  const [value, , capabilityObj] = useCapabilityValue({
    capabilityId: 'speaker_playing',
    deviceId: props.device.id,
  });
  const [speakerTrackValue] = useCapabilityValue({
    capabilityId: 'speaker_track',
    deviceId: props.device.id,
  });
  const [speakerArtistValue] = useCapabilityValue({
    capabilityId: 'speaker_artist',
    deviceId: props.device.id,
  });

  if (capabilityObj == null) {
    return null;
  }

  if (value === true) {
    const size = props.tileSize === DeviceTile.size.large ? 'large' : 'medium';
    const statusLabel = getSpeakerPlayingLabel({
      artist: speakerArtistValue,
      i18n,
      track: speakerTrackValue,
    });

    return (
      <div className={styles.root} data-size={size} data-state="playing">
        <SpeakerEqualizer isActive={true} size="status" />

        <div className={styles.statusText} data-state="playing" title={statusLabel}>
          {statusLabel}
        </div>
      </div>
    );
  }

  if (value !== false) {
    return null;
  }

  return (
    <div className={styles.root} data-state="paused">
      <div className={styles.statusText} data-state="paused">
        {i18n.messageFormatter('device.media.paused', undefined, pausedFallbackLabel)}
      </div>
    </div>
  );
}

function getSpeakerPlayingLabel(props) {
  return (
    getNonEmptyString(props.track) ??
    getNonEmptyString(props.artist) ??
    props.i18n.messageFormatter('device.media.playing', undefined, playingFallbackLabel)
  );
}

function getNonEmptyString(value) {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmedValue = value.trim();

  if (trimmedValue === '') {
    return null;
  }

  return trimmedValue;
}
